'use strict'

let self

export default self = {
  container : document.querySelector('.accordion'),
  itemsContainer : null,
  heightWrapper : null,
  trigger : null,
  titles : null,


  init : () => {
    self.itemsContainer = document.querySelector('.accordion .accordion__items');
    self.heightWrapper = document.querySelector('.accordion .accordion__height-wrapper');
    self.trigger = document.querySelector('.accordion .accordion__trigger');
    self.titles = document.querySelectorAll('.accordion .accordion__title');

    if(self.trigger){
      self.trigger.addEventListener("click", self.toggleAccordion)
    }
    Array.from(self.titles).forEach( title => title.addEventListener("click", self.toggleAccordionItem) )
  },

  toggleAccordion : e => {
    //self.toggleHeightOf(self.itemsContainer, self.heightWrapper)
    self.trigger.classList.toggle("rotate")
  },

  toggleHeightOf : (content, wrap) => {
    if (content.getAttribute("style")) {
      content.removeAttribute("style")
    } else {
      content.style.height = `${wrap.clientHeight}px`
    }
  },

  toggleAccordionItem : e => {
    let el = e.currentTarget
    let parent = el.parentNode
    let content = parent.querySelector('.accordion__content')
    let wrap = parent.querySelector('.accordion__content .wrapper')

    parent.classList.toggle("open")
    //self.toggleHeightOf(content, wrap)

  },

  updateContainerHeight : (action, wrap) => {
    let h

    switch (action) {
      case "add":
        h = self.itemsContainer.clientHeight + wrap.clientHeight
      break;
      case "subtract":
        h = self.itemsContainer.clientHeight - wrap.clientHeight
      break;
    }

    self.itemsContainer.style.height = `${h}px`
  }
}
